//@flow
import * as Immutable from 'immutable';

import { RiderRating } from 'common/models/flow/RiderRating';
import DataUtils from 'common/utils/DataUtils';
import NumberUtils from 'common/utils/NumberUtils';
import I18nHelper from 'common/helpers/I18nHelper';

import {
    validatable,
    validate,
    validateAll,
    softValidateAll
} from 'common/utils/ValidationUtil';

import type { RiderRatingModelType } from 'common/models/flow/RiderRating';

const translationsNamespace = ['validations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

@validatable
class InternalRiderRating extends RiderRating {
    static fromJS(json: RiderRatingModelType): InternalRiderRating {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    @softValidateAll
    hasValidationErrors(): boolean {
        return false;
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }

    @validate
    setRating(rating: ?string) {
        return super.setRating(rating);
    }

    validateRating() {
        if (
            !DataUtils.isEmpty(this.rating) &&
            !NumberUtils.isNumeric(this.rating)
        ) {
            return nsTranslate('competency.ratingNotANumber');
        }
        if (this.rating < 0 || this.rating > 5) {
            return nsTranslate('competency.ratingOutOfRange');
        }
    }
}

export { InternalRiderRating as RiderRating };
